import React from "react";

//This util fixes the issue with forwardRef not working with generic typed components
// solution found here https://www.totaltypescript.com/forwardref-with-generic-components

function fixedForwardRef<T, P = object>(
	render: (props: P, ref: React.Ref<T>) => React.ReactNode
): (props: P & React.RefAttributes<T>) => React.ReactNode {
	return React.forwardRef(render) as any;
}

export default fixedForwardRef;
